import { IAgricultureParameter } from '@/modules/agriculture/ts';
import { cacheLastSearchResult } from '@/modules/common/helpers/cache-search-result.helper';
import {
  indicateWheatType,
  multiWheatType,
} from '@/modules/common/helpers/wheat-type.helper';
import { validateModal } from '@/modules/mixing/components/mixing-by-params-modal/utils';
import { validateRangesModal } from '@/modules/mixing/components/mixing-by-params-modal/utils/validate-ranges-modal.util';
import { notification } from 'antd';
import { NavigateFunction } from 'react-router-dom';
import { ISearchState } from '../ts/index.types';

export const submitRangesFx = async ({
  data,
  navigate,
  resultData,
  wheatRangesForValidation,
}: {
  data: ISearchState;
  navigate: NavigateFunction;
  resultData: any;
  wheatRangesForValidation: {
    gluten: IAgricultureParameter;
    humidity: IAgricultureParameter;
    idk: IAgricultureParameter;
    cp: IAgricultureParameter;
    protein: IAgricultureParameter;
    nature: IAgricultureParameter;
  };
}) => {
  const checkedWarehouses = data?.stores?.filter((item) => item.checked === true);
  const validationResult = validateRangesModal(data, wheatRangesForValidation);

  if (validationResult.errors.length > 0)
    notification.warning({
      message: `Не заданы значения для полей: ${validationResult.errors.join(', ')}`,
    });
  if (validationResult.warnings.length > 0)
    validationResult.warnings.map((item) =>
      notification.warning({
        message: item.label,
      }),
    );

  if (validationResult.success) {
    const wheatType = indicateWheatType(data.wheatData.sort, data.wheatData.type);
    const params = {
      warehouse_id: checkedWarehouses.map((item) => item.id),
      //harvest_year: data.rangesData.year[1],
      cp: data.rangesData.cp[0],
      cp_to: data.rangesData.cp[1],
      nature: data.rangesData.nature[0],
      nature_to: data.rangesData.nature[1],
      humidity: data.rangesData.humidity[0],
      humidity_to: data.rangesData.humidity[1],
      protein: data.rangesData.protein[0],
      protein_to: data.rangesData.protein[1],
      gluten: data.rangesData.gluten[0],
      gluten_to: data.rangesData.gluten[1],
      idk: data.rangesData.idk[0],
      idk_to: data.rangesData.idk[1],
      //deviation: +data.wheatData.divergence,
      class: +data.wheatData.class,
      type: wheatType || undefined,
      range: true,
      //temperature: 24,
    };
    const urlParams = new URLSearchParams(params as any).toString();
    // try {
    //   await fetchMixingParamsData(params);
    // } catch (err) {
    //   return;
    // }
    if (resultData?.errors) {
      const errorArray = Object.entries(resultData?.errors)?.flatMap(
        ([key, value]) => value,
      );
      errorArray.map((item) =>
        notification.warning({
          message: String(item),
        }),
      );
      return;
    }
    // navigate(`/mixing/manual?${urlParams}`)
    cacheLastSearchResult(`/mixing/manual?${urlParams}`);
    navigate({ pathname: '/mixing/manual', search: urlParams });
  }
};
